<style lang="scss" scoped>
.flex-container {
    display: flex;

    .input-item {
        width: 40%;
    }
    .tip-item {
        width: 40%;
        margin-left: 60px;

        .tip-p {
            color: #ed4014;
            p {
                line-height: 23px;
            }
        }
    }
}
</style>
<template>
    <div style="position: relative">
        <compWrapper :title="$t('erp.rules.rulenews',{defaultValue:'规则信息'})" theme="primary">
            <compFormQuery
                v-if="queryType == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="baseInfo"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="baseInfo"
                :labelWidth="120"
            ></compFormEdit>
            <template v-if="queryType !== 'query'" slot="footer">
                <Button class="margin-right-20" type="info" @click="submit"
                    >{{$t('global.common.save',{defaultValue:'保存'})}}</Button
                >
                <Button class="margin-right-20" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
            </template>
        </compWrapper>
        <compWrapper :title="$t('erp.rules.rulechose',{defaultValue:'规则筛选条件'})" theme="primary">
            <Form
                v-if="queryType == 'query'"
                :model="formData"
                :labelWidth="150"
                style="padding: 15px 0"
            >
                <FormItem :label="$t('erp.distribution.issfp',{defaultValue:'是否SFP'})+$t('erp.channelbase.order',{defaultValue:'订单'})">
                    <div class="font-weight">
                        {{ handleSelect(sfpTypeList, formData.sfpType).label }}
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.b2c.channel_account',{defaultValue:'渠道账号'})">
                    <div class="font-weight">
                        <div v-if="formData.accountType === 'all'">
                            {{$t('bi.work.task_all',{defaultValue:'全部'})}}{{$t('global.common.channel',{defaultValue:'渠道'})}}
                        </div>
                        <div v-else>
                            <p v-for="item in targetAccountList" :key="item">
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                    <div class="font-weight">
                        <div v-if="formData.productType === 'all'">
                            {{$t('bi.work.task_all',{defaultValue:'全部'})}}{{$t('global.common.project',{defaultValue:'项目'})}}
                        </div>
                        <div v-else>
                            <p v-for="item in targetProductList" :key="item">
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.contacterpsku',{defaultValue:'包含ERPSKU'})">
                    <div class="font-weight">
                        <div v-if="!dataList.skuList.length">--</div>
                        <div v-else>
                            <p v-for="item in dataList.skuList" :key="item.key">
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.postlength',{defaultValue:'邮编范围'})">
                    <div class="font-weight">
                        <div v-if="!dataList.postcodeList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.postcodeList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.addresskey',{defaultValue:'收货地址包含关键字'})">
                    <div class="font-weight">
                        <div v-if="!dataList.addressList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.addressList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.amountlength',{defaultValue:'销售总金额范围'})">
                    <div class="font-weight">
                        <div v-if="!dataList.orderAmountList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.orderAmountList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.sellnumlength',{defaultValue:'Seller SKU总数量范围'})">
                    <div class="font-weight">
                        <div v-if="!dataList.orderTotalList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.orderTotalList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.computed_formula',{defaultValue:'计算公式'})">
                    <div class="font-weight">
                        <div v-if="!dataList.erpskuSizeFormulaList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.erpskuSizeFormulaList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.b2c.hippingMethodCode',{defaultValue:'承运商服务'})">
                    <div class="font-weight">
                        <div v-if="!dataList.carrierCodeList.length">--</div>
                        <div v-else>
                            <p
                                v-for="item in dataList.carrierCodeList"
                                :key="item.key"
                            >
                                {{ item }}
                            </p>
                        </div>
                    </div>
                </FormItem>
            </Form>
            <Form
                v-else
                ref="dataForm"
                :model="formData"
                :labelWidth="150"
                style="padding: 15px 0"
            >
                <FormItem :label="$t('erp.distribution.issfp',{defaultValue:'是否SFP'})+$t('erp.channelbase.order',{defaultValue:'订单'})" prop="sfpType" :rules="required">
                    <RadioGroup v-model="formData.sfpType">
                        <Radio
                            v-for="item in sfpTypeList"
                            :key="item.key"
                            :label="item.value"
                            >{{ item.label }}</Radio
                        >
                    </RadioGroup>
                </FormItem>
                <FormItem :label="$t('erp.b2c.channel_account',{defaultValue:'渠道账号'})" prop="accountType" :rules="required">
                    <RadioGroup v-model="formData.accountType">
                        <Radio label="all">{{$t('bi.work.task_all',{defaultValue:'全部'})}}{{$t('global.common.channel',{defaultValue:'渠道'})}}</Radio>
                        <Radio label="part">{{$t('erp.rules.partaccount',{defaultValue:'指定渠道'})}}</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formData.accountType === 'part'">
                    <Transfer
                        :data="accountList"
                        filterable
                        :target-keys="targetAccountList"
                        :list-style="listStyle"
                        :render-format="renderList"
                        @on-change="handleAccountChange"
                    >
                    </Transfer>
                </FormItem>
                <FormItem :label="$t('global.common.project',{defaultValue:'项目'})" prop="productType" :rules="required">
                    <RadioGroup v-model="formData.productType">
                        <Radio label="all">{{$t('bi.work.task_all',{defaultValue:'全部'})}}{{$t('global.common.project',{defaultValue:'项目'})}}</Radio>
                        <Radio label="part">{{$t('fbb.inbound.choose',{defaultValue:'选择'})}}{{$t('global.common.project',{defaultValue:'项目'})}}</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formData.productType === 'part'">
                    <Transfer
                        :data="productList"
                        filterable
                        :target-keys="targetProductList"
                        :list-style="listStyle"
                        :render-format="renderList"
                        @on-change="handleProductChange"
                    >
                    </Transfer>
                </FormItem>
                <FormItem :label="$t('erp.rules.contacterpsku',{defaultValue:'包含ERPSKU'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.skuList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.cantacterp_tip',{defaultValue:'<p>填写说明：</p><p>1.一行一个ERP SKU，精确匹配；</p><p>2.多行表示多个EPR SKU。</p><p>举例：</p<p>STM1301000023</p><p>STM1301000022</p><p>STM1301000021</p>'})"></div>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.postlength',{defaultValue:'邮编范围'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.postcodeList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.postlength_tip',{defaultValue:'<p>填写说明：</p><p>1. 一行一个邮编范围；</p><p>2.20000~30000表示邮编在20000与30000间，并且包含20000和30000；</p><p>3.40000~40000表示只有这一个邮编40000，不可以填写单独的数字。</p><p>举例：</p><p>20000~29999</p><p>40000~49999</p><p>60000~79999</p>'})">
                                
                            </div>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.addresskey',{defaultValue:'收货地址包含关键字'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.addressList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.address_tip',{defaultValue:'<p>填写说明：</p><p>1. 一行一个关键字，精确匹配；</p><p>2. 多行关键字表示地址包含其中一行的地址。</p><p>举例：</p><p>1.AAA</p><p>BBB 表示地址中包含AAA或者包含BBB</p><p>2.AAA BBB表示地址中包含AAA BBB</p>'})">
                                
                            </div>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.amountlength',{defaultValue:'销售总金额范围'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.orderAmountList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.amountlength_tip',{defaultValue:'<p>填写说明：</p><p>1. 一行一个范围；</p><p>2.200~300表示销售总金额在200与300间，并且包含200和300；</p><p>3.400~400表示只有这一个总金额400，不可以填写单独的数字。</p><p>举例：</p><p>200~299</p><p>400~400</p>'})">
                                
                            </div>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.sellnumlength',{defaultValue:'Seller SKU总数量范围'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.orderTotalList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.sellnumlength_tip',{defaultValue:'<p>填写说明：</p><p>1. 一行一个范围；</p><p>2.200~300表示数量在200与300间，并且包含200和300；</p><p>3.400~400表示只有这一个数量400，不可以填写单独的数字。</p><p>举例：</p><p>200~299</p><p>400~400</p>'})">
                                
                            </div>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.rules.computed_formula',{defaultValue:'计算公式'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.erpskuSizeFormulaList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.computed_formula_tip',{defaultValue:'<p>填写说明：</p><p>定义字段，长、宽、高：LENGTH、WIDTH、HEIGHT，</p><p>单个ERPSKU重量：WEIGHT，ERPSKU总重量：T_WEIGHTS</p><p>单个ERPSKU数量：NUM，ERPSKU总数量：T_NUMS</p><p>一行一个公式，公式返回值的范围用符号“&&”连接，表示且。</p><p>多行公式表示或，匹配到其中一行公司即可。</p><p>举例：</p><p>LENGTH+(WIDTH+HEIGTH)*2<100 && LENGTH+(WIDTH+HEIGTH)*2>50  &&  50<LBS&&LBS <100</p>'})">
                            </div>
                        </div>
                    </div>
                </FormItem>
                <FormItem :label="$t('erp.b2c.hippingMethodCode',{defaultValue:'承运商服务'})">
                    <div class="flex-container" style="display: flex">
                        <div class="input-item">
                            <Input
                                :rows="7"
                                v-model="formData.dataList.carrierCodeList"
                                type="textarea"
                            ></Input>
                        </div>
                        <div class="tip-item">
                            <div class="tip-p" v-html="$t('erp.rules.carrierCodeList',{defaultValue:'<p>填写说明：</p><p>1.一行一个承运商服务，精确匹配；</p><p>2.多行表示多个承运商服务；</p><p>举例：</p><p>AMXL</p><p>UPSG</p>'})">
                                
                            </div>
                        </div>
                    </div>
                </FormItem>
            </Form>
        </compWrapper>
        <Spin v-if="loading" fix size="large"></Spin>
    </div>
</template>

<script>
import {
    HttpGetRuleDetail,
    HttpSaveRuleData,
    HttpFilterDisabledWarehouse,
} from "@/service/rules/rules";
import { mapState, mapGetters } from "vuex";
import mixin from "./mixin";
import mixins from "../proddevelop/mixins";
export default {
    props: ["level", "type", "id"],
    mixins: [mixin],
    data() {
        return {
            ruleId: this.id ? this.id : this.$route.query.id,
            queryType: this.type ? this.type : this.$route.params.type,
            // 优先级
            orderLevel: this.level ? this.level : this.$route.params.level,
            loading: false,
            listStyle: {
                width: "40%",
                minWidth: "260px",
                height: "360px",
            },
            baseInfo: {},
            // formatter: {
            //     skuList: ''
            // },
            formData: {
                accountType: "all",
                productType: "all",
                sfpType: 2,
                // 字符串数据
                dataList: {
                    // sku
                    skuList: [],
                    // 邮编
                    postcodeList: [],
                    // 地址
                    addressList: [],
                    // 订单金额
                    orderAmountList: [],
                    // sku数量
                    orderTotalList: [],
                    // 尺寸公式
                    erpskuSizeFormulaList: [],
                    // 承运商服务
                    carrierCodeList: []
                },
            },
            // 仓库源列表
            warehouseList: [],
            // 渠道源列表
            accountList: [],
            // 渠道数据列表
            targetAccountList: [],
            // 产品源列表
            productList: [],
            // 产品数据列表
            targetProductList: [],
            // 数组，方便统一处理，存放在一个对象中
            dataList: {
                // sku
                skuList: [],
                // 邮编
                postcodeList: [],
                // 地址
                addressList: [],
                // 订单金额
                orderAmountList: [],
                // sku数量
                orderTotalList: [],
                // 尺寸公式
                erpskuSizeFormulaList: [],
                // 承运商服务
                carrierCodeList: []
            },
            required: {
                required: true,
                message: "",
            },
        };
    },
    watch: {
        // 防止第一次加载接口还未返回值
        getNewAccountIdList: {
            immediate: true,
            deep: true,
            handler(val) {
                this.handleAccountList(val);
            },
        },
        getNewProductList: {
            immediate: true,
            deep: true,
            handler(val) {
                this.handleProductList(val);
            },
        },
    },
    async created() {
        // console.log(this.ruleId, this.queryType, this.orderLevel);
        let filterDisabledWarehouse = [];
        await HttpFilterDisabledWarehouse().then(
            (res) => {
                filterDisabledWarehouse = res.data;
                // console.log(res);
            },
            (err) => {}
        );
        this.warehouseList = filterDisabledWarehouse
            .filter((item) => {
                // 过滤只展示服务仓和虚拟仓
                return item.warehouseType === 1 || item.warehouseType === 5;
            })
            .map((item) => {
                return {
                    label: item.title
                        ? `${item.code}(${item.title})`
                        : item.code,
                    value: item.id,
                    attach: {
                        code: item.code,
                        warehouseType: item.warehouseType,
                    },
                };
            });
        if (this.queryType !== "add") {
            this.loading = true;
            await this.getDetail();
        }
    },
    computed: {
        ...mapGetters("diction", [
            "getNewProductList",
            "getNewAccountIdList",
            "getNewWarehouseIdList",
        ]),
        ...mapGetters("dictionary", ["getFilterDisabledWarehouse"]),
        getBase() {
            return [
                {
                    label: this.$t('erp.rules.rulename',{defaultValue:'规则名称'}),
                    key: "ruleName",
                    span: 24,
                },
                {
                    label: this.$t('erp.b2c.search_outwarehouse',{defaultValue:'发货仓库'}),
                    key: "warehouseId",
                    tag: "vSelect",
                    options: this.warehouseList,
                    show: this.orderLevel != 5,
                    span: 24,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    on: {
                        "on-change": (val) => {
                            this.baseInfo.warehouseName = this.warehouseList.filter(
                                (item) => {
                                    return item.value == val;
                                }
                            )[0].label;
                        },
                    },
                },
            ];
        },
        sfpTypeList() {
            return [
                {
                    label: this.$t('bi.work.task_all',{defaultValue:'全部'}),
                    value: 0,
                },
                {
                    label: this.$t('erp.rules.yessfp',{defaultValue:'SFP订单'}),
                    value: 1,
                },
                {
                    label: this.$t('erp.rules.nosfp',{defaultValue:'非SFP订单'}),
                    value: 2,
                },
            ];
        },
    },
    methods: {
        async submit() {
            let flag = true;
            await this.$refs.editform.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            await this.$refs.dataForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            // 处理数据数组
            let resultData = {
                ...this.baseInfo,
                sfpType: this.formData.sfpType,
            };
            // 渠道
            if (this.formData.accountType === "all") {
                resultData.channelList = [
                    {
                        content: "all",
                    },
                ];
            } else {
                resultData.channelList = this.targetAccountList.map((item) => {
                    return {
                        content: item,
                    };
                });
            }
            // 项目
            if (this.formData.productType === "all") {
                resultData.productLineList = [
                    {
                        content: "all",
                    },
                ];
            } else {
                resultData.productLineList = this.targetProductList.map(
                    (item) => {
                        return {
                            content: item,
                        };
                    }
                );
            }
            Object.keys(this.formData.dataList).map((key) => {
                // console.log(this.formData.dataList[key])
                if (
                    !this.formData.dataList[key] ||
                    !this.formData.dataList[key].length
                )
                    this.dataList[key] = [];
                else {
                    this.dataList[key] = this.handleStringToArray(
                        this.formData.dataList[key]
                    );
                }
            });
            for (let i = 0; i < this.dataList.skuList.length;) {
                let item = this.dataList.skuList[i];
                item.content = item.content.replace(/ +/g, '');
                if (!item.content) {
                    this.dataList.skuList.splice(i, 1);
                }
                else {
                    i ++;
                }
            }
            let nowData = this.typeList.filter((item) => {
                return item.type == this.orderLevel;
            })[0];
            resultData = {
                ...resultData,
                ...this.dataList,
                ruleType: nowData.ruleType,
                sortorder: nowData.sortorder,
                orgId: global.SYSID,
            };
            if (this.queryType === "edit") {
                resultData.id = this.ruleId;
            }
            this.loading = true;
            await HttpSaveRuleData(resultData)
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        if (this.orderLevel == 5) {
                            this.$router.push({ name: "auditRules" });
                        } else {
                            this.$router.push({ name: "warehouseDeliver" });
                        }
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * 获取详情数据
         */
        async getDetail() {
            await HttpGetRuleDetail({
                ruleId: this.ruleId,
            })
                .then(
                    (res) => {
                        this.baseInfo = {
                            ruleName: res.data.ruleName,
                            warehouseName: res.data.warehouseName,
                            warehouseId: res.data.warehouseId,
                        };
                        // 处理渠道数据
                        if (res.data.channelList[0].content === "all") {
                            this.formData.accountType = "all";
                        } else {
                            this.formData.accountType = "part";
                            this.targetAccountList = this.handleDataArr(
                                res.data.channelList
                            );
                        }
                        // 处理产品数据
                        if (res.data.productLineList[0].content === "all") {
                            this.formData.productType = "all";
                        } else {
                            this.formData.productType = "part";
                            this.targetProductList = this.handleDataArr(
                                res.data.productLineList
                            );
                        }
                        // sfpType
                        this.formData.sfpType = res.data.sfpType;
                        // 获取数据列表
                        let originDataList = {
                            skuList: res.data.skuList,
                            postcodeList: res.data.postcodeList,
                            addressList: res.data.addressList,
                            orderAmountList: res.data.orderAmountList,
                            orderTotalList: res.data.orderTotalList,
                            erpskuSizeFormulaList: res.data.erpskuSizeFormulaList,
                            carrierCodeList: res.data.carrierCodeList
                        };
                        // 处理数据
                        Object.keys(originDataList).map((item) => {
                            // 存放处理后的数组
                            this.dataList[item] = this.handleDataArr(
                                originDataList[item],
                                false
                            );
                            // 存放展示/编辑用字符串
                            this.formData.dataList[
                                item
                            ] = this.handleArrayToString(this.dataList[item]);
                        });
                        // 查询状态 需要不同的数据结构
                        if (this.queryType === "query") {
                            this.targetAccountList = this.targetAccountList.map(
                                (item) => {
                                    let result = this.accountList.filter(
                                        (accountItem) => {
                                            return accountItem.key === item;
                                        }
                                    )[0];
                                    if (!result) return {};
                                    return result.label;
                                }
                            );
                            this.targetProductList = this.targetProductList.map(
                                (item) => {
                                    let result = this.productList.filter(
                                        (accountItem) => {
                                            return accountItem.key === item;
                                        }
                                    )[0];
                                    if (!result) return {};
                                    return result.label;
                                }
                            );
                        }
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            if (this.orderLevel == 5) {
                this.$router.push({ name: "auditRules" });
            } else {
                this.$router.push({ name: "warehouseDeliver" });
            }
        },
        /**
         * 处理数据源数组
         * @param target 结果数组
         * @param data 从接口拿到的数据源
         */
        handleDataArr(data, needInt = true) {
            return data.map((item) => {
                let result;
                if (needInt) {
                    result = parseInt(item.content);
                } else {
                    result = item.content;
                }
                return result;
            });
        },
        /**
         * 处理数组成字符串
         */
        handleArrayToString(arr) {
            return arr.join("\n");
        },
        /**
         * 将分行的字符串解析为数组
         * @param string 分行的字符串
         */
        handleStringToArray(string) {
            let arr = string.split(/\n/g);
            return arr.map((item) => {
                return {
                    content: item,
                };
            });
        },
        /**
         * 处理select选框在查看状态的展示
         */
        handleSelect(dataSource, data) {
            return dataSource.filter((item) => {
                return item.value === data;
            })[0];
        },
        renderList(item) {
            return item.label;
        },
        /**
         * 处理渠道源列表
         */
        handleAccountList(data) {
            this.accountList = data.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        },
        handleAccountChange(newTargetKeys, direction, moveKeys) {
            this.targetAccountList = newTargetKeys;
        },
        /**
         * 处理产品源列表
         */
        handleProductList(data) {
            this.productList = data.map((item) => {
                return {
                    label: item.label,
                    key: item.value,
                };
            });
        },
        handleProductChange(newTargetKeys, direction, moveKeys) {
            this.targetProductList = newTargetKeys;
        },
    },
};
</script>

<style>
</style>